import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, MessageCircle, ArrowUpRight } from "lucide-react";
import { useT } from "@/i18n_extra3";
import { scrollToId, whatsappUrl } from "@/utils";

export const ExitIntent = () => {
  const t = useT();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("cr-exit-shown")) return;
    const handler = (e) => {
      if (!e.relatedTarget && e.clientY <= 8) {
        setOpen(true);
        sessionStorage.setItem("cr-exit-shown", "1");
        document.removeEventListener("mouseout", handler);
      }
    };
    const timer = setTimeout(() => document.addEventListener("mouseout", handler), 12000);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseout", handler);
    };
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[150] bg-black/60 backdrop-blur-sm flex items-center justify-center px-5"
          onClick={() => setOpen(false)}
          data-testid="exit-intent-modal"
        >
          <motion.div
            initial={{ scale: 0.9, y: 30 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 22 }}
            className="relative bg-[#FAF9F6] rounded-3xl max-w-md w-full p-10 text-center shadow-2xl border-t-4 border-[#D4AF37]"
            onClick={(e) => e.stopPropagation()}
          >
            <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-black/40 hover:text-black transition-colors" aria-label="Close" data-testid="exit-intent-close">
              <X className="w-5 h-5" />
            </button>
            <img src="/assets/logo-icon.png" alt="ClearRoute" className="h-14 w-auto mx-auto mb-6" />
            <h3 className="font-display font-bold text-3xl tracking-tight text-[#111111]">{t.exit.title}</h3>
            <p className="mt-4 text-black/60 leading-relaxed">{t.exit.sub}</p>
            <div className="mt-8 flex flex-col gap-3">
              <a
                href={whatsappUrl(t.whatsapp.prefill)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="exit-intent-whatsapp"
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold px-6 py-4 rounded-full hover:scale-[1.02] transform transition-transform duration-300"
              >
                <MessageCircle className="w-5 h-5" /> {t.exit.whats}
              </a>
              <button
                onClick={() => { setOpen(false); scrollToId("#quote"); }}
                data-testid="exit-intent-quote"
                className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-black font-bold px-6 py-4 rounded-full hover:scale-[1.02] transform transition-transform duration-300"
              >
                {t.exit.quote} <ArrowUpRight className="w-5 h-5" />
              </button>
              <button onClick={() => setOpen(false)} className="text-black/40 text-sm hover:text-black/70 transition-colors mt-1" data-testid="exit-intent-dismiss">
                {t.exit.dismiss}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
